import Router from 'next/router'

/** The SDK serialises this frontend-owned field as sentry-frontend_path baggage. */
export const addRouteToBaggage = (context: Record<string, string | undefined>): void => {
  // pathname excludes query values and concrete dynamic IDs.
  const route = Router.router?.pathname
  if (route) context.frontend_path = route
}
